import { Button } from "@mui/material";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";

export default function ResetFilters({ resetAll, sx }) {
  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={<RestartAltRoundedIcon />}
      onClick={resetAll}
      sx={{
        textTransform: "none",
        fontWeight: 700,
        borderRadius: 999,
        ...sx,
      }}
    >
      Reset filters
    </Button>
  );
}
